import { axiosAPI } from 'lib/api';
import { logInfo } from 'utils/logging';
import { getCSRFTOKEN } from 'utils/cookie/getCSRFToken';
import { PostAskDataRes } from '../AskModal.types';

const postAskData = async (
  text: string,
  category: number,
  grade: number,
  userNotAuth?: boolean,
): Promise<PostAskDataRes | null> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN');
  try {
    return await axiosAPI(
      {
        url: `/otvety/api/questions${userNotAuth ? '/stash_not_auth' : ''}`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrf_token,
        },
        data: JSON.stringify({
          question: {
            body: text,
            category_id: category,
            grade,
          },
        }),
      },
      undefined,
    );
  } catch (error: any) {
    logInfo(error.toString(), true);
    return null;
  }
};

export default postAskData;
